import { Modal } from '@innovationdepartment/proxima-ui';
import RemoveTagConfirmationView from './RemoveTagConfirmation.View';

export type RemoveTagConfirmationProps = {
  open: boolean;
  close: () => void;
  confirm: () => void;
  tagDisplayName: string;
  isLoading: boolean;
};

const RemoveTagConfirmation = ({
  open,
  confirm,
  close,
  tagDisplayName,
  isLoading
}: RemoveTagConfirmationProps) => (
  <Modal noPadding={false} open={open} title={`Remove Tag ${tagDisplayName} from Brand?`}>
    <RemoveTagConfirmationView
      confirm={confirm}
      close={close}
      tagDisplayName={tagDisplayName}
      isLoading={isLoading}
    />
  </Modal>
);

export default RemoveTagConfirmation;
